var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Translate from '../Translate';
import marked from 'marked';
import Button from '../../components/Button';

var AcceptUpdatedTaC = function (_Component) {
  _inherits(AcceptUpdatedTaC, _Component);

  function AcceptUpdatedTaC() {
    _classCallCheck(this, AcceptUpdatedTaC);

    return _possibleConstructorReturn(this, (AcceptUpdatedTaC.__proto__ || Object.getPrototypeOf(AcceptUpdatedTaC)).apply(this, arguments));
  }

  _createClass(AcceptUpdatedTaC, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onAccept = _props.onAccept,
          termsContent = _props.termsContent,
          current = _props.current,
          isLoading = _props.isLoading;


      return React.createElement(
        'div',
        { className: 'AcceptUpdatedTaC' },
        React.createElement(
          'header',
          null,
          React.createElement(Translate, {
            id: 'label.acceptupdatedterms',
            tagName: 'h2',
            defaultMessage: 'Action required'
          }),
          React.createElement(Translate, {
            id: 'message.acceptupdatedterms',
            tagName: 'p',
            values: { current: current },
            defaultMessage: 'I accept the updated terms and conditions ({current}).'
          })
        ),
        React.createElement('div', {
          className: 'AcceptUpdatedTaC__content',
          dangerouslySetInnerHTML: { __html: marked(termsContent || '') }
        }),
        React.createElement(
          Button,
          {
            className: 'button primary',
            onClick: onAccept,
            isLoading: isLoading },
          React.createElement(Translate, { id: 'action.accept' })
        )
      );
    }
  }]);

  return AcceptUpdatedTaC;
}(Component);

export default AcceptUpdatedTaC;